var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagHawaii(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4307C24.8366 32.4307 32 25.2672 32 16.4307C32 7.59411 24.8366 0.430664 16 0.430664C7.16344 0.430664 0 7.59411 0 16.4307C0 25.2672 7.16344 32.4307 16 32.4307Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 32.4307C20.0569 32.4307 23.7608 30.9197 26.5812 28.4307H5.41797C8.23841 30.9197 11.9423 32.4307 15.9996 32.4307Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.504059 20.4308C0.869371 21.8499 1.42475 23.1926 2.141 24.4308H29.8589C30.5752 23.1926 31.1306 21.8499 31.4959 20.4308L16 19.2134L0.504059 20.4308Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4959 12.4307C31.1306 11.0115 30.5753 9.66879 29.859 8.43066L16 8.08285C16 5.28829 16 2.64723 16 0.430664C14.8114 0.430664 13.6531 0.560352 12.5384 0.806164C12.517 0.810914 2.08694 9.03804 2.08694 16.4307C2.35363 16.477 16 17.822 16 17.822C16 17.822 16 14.7744 16 12.4307H31.4959Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.4132V2.41319H10.9328L12.5389 0.807129C5.94569 2.26125 0.87975 7.7815 0.104375 14.6045C0.03625 15.2039 0 15.8129 0 16.4306H8.10437V13.2416L11.3249 16.4306H17.0489L10.9327 10.4132H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0073 16.4309L9.98994 10.4135H8.10437V10.4135L14.1217 16.4309H6.08694V8.43086H29.859C28.9879 6.92505 27.878 5.5748 26.5817 4.43086H6.08694V3.87305C4.47269 5.14911 3.11069 6.72961 2.08694 8.52798V16.4309H0C0 17.812 0.175 19.1524 0.504062 20.4309H31.4959C31.825 19.1524 32 17.812 32 16.4309H16.0073Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagHawaii);
export default __webpack_public_path__ + "static/media/flag_hawaii.a1faa8e3d7b6eb18277a7bb85afb5ddc.svg";
export { ForwardRef as ReactComponent };